import type { InspectionLocation } from '@areapif/areapif-shared'

/**
 * Every location, in the order the filters present them — PIF first, as the
 * historical list has always ordered it, then the terminals.
 *
 * Keyed by `InspectionLocation` rather than written as a plain array so that a
 * location the database gains, but this file omits, is a missing-property
 * error. An annotated array would only have caught an invented member.
 */
const ALL_LOCATIONS: Record<InspectionLocation, true> = {
  PIF: true,
  APMT: true,
  BEST: true,
  PORTNOU: true,
}

export const INSPECTION_LOCATIONS = Object.keys(ALL_LOCATIONS) as InspectionLocation[]
